import React, { useEffect, useState } from 'react'

import { Button, Card, Col, Divider, Form, Row } from 'antd'
import { Formik } from 'formik'
import moment from 'moment'

import InfoIcon from '../../../assets/images/infoIcon.svg'
import MapIcon from '../../../assets/images/mapIcon.svg'
import CustomSelect from '../../../components/CustomSelect/customSelect'
import FormHeader from '../../../components/FormHeader/FormHeader'
import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import { SEARCH_CULTIVARS_HISTORY_SCHEMA } from './CultivarsSchema'

const SearchCultivarsHistory = ({
  filterCultivarsByDate,
  customerId,
  formattedYears = [],
  formattedMonths = [],
  selectedDistrictId
}) => {
  const [customerName, setCustomerName] = useState('')
  const [regionDistrict, setRegionDistrict] = useState('')

  const [months, setMonths] = useState([])

  const [selectedYear, setSelectedYear] = useState(false)

  useEffect(() => {
    retrieveCustomerLocations(customerId)
    setMonths(formattedMonths)
  }, [customerId, formattedMonths])

  function onSubmit(values) {
    filterCultivarsByDate(values)
  }

  async function retrieveCustomerLocations(id) {
    try {
      const params = { districtId: selectedDistrictId }
      const items = await request(api.listCustomerLocations(id, { params }))

      const { districtName, regionName } = items[0]
      const customer = await api.getCustomer(customerId)
      setCustomerName(customer.name)
      setRegionDistrict(`${regionName}/${districtName}`)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  function handleSelectedYear(value) {
    const currentYear = moment().year()
    const currentMonth = moment().month() + 1

    setSelectedYear(true)

    if (Number(value) === currentYear) {
      const result = formattedMonths.filter((month) => month.value < Number(currentMonth))
      setMonths(result)
    } else {
      setMonths(formattedMonths)
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{}}
      validationSchema={SEARCH_CULTIVARS_HISTORY_SCHEMA}
      onSubmit={onSubmit}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ values, errors, setFieldValue, submitForm, resetForm }) => (
        <Form layout="vertical">
          <FormHeader
            color="#000"
            title={getMessage('customer.tab.cultivars.history')}
            orientation="left"
            type="horizontal"
          />

          <div className="main-cards" style={{ padding: '0px 20px 20px 20px' }}>
            <Card className="ant-card-bordered card">
              <div className="container-card">
                <img src={InfoIcon} alt="InfoIcon" width={25} style={{ marginRight: 10 }} />
                <div className="label-card-info">
                  <span>Nome do eleito</span>
                  <span style={{ fontWeight: 'bold' }}>{customerName}</span>
                </div>
              </div>
            </Card>

            <Card className="ant-card-bordered card">
              <div className="container-card">
                <img src={MapIcon} alt="MapIcon" width={25} style={{ marginRight: 10 }} />
                <div className="label-card-info">
                  <span>Regional / Distrito</span>
                  <span style={{ fontWeight: 'bold' }}>{regionDistrict}</span>
                </div>
              </div>
            </Card>
          </div>

          <Row type="flex" justify="start">
            <CustomSelect
              showSearch
              field="cultivarYear"
              label={getMessage('calendar.year')}
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              values={formattedYears}
              required={true}
              onChange={handleSelectedYear}
            />
            <CustomSelect
              showSearch
              field="cultivarMonth"
              label={getMessage('calendar.month')}
              errors={errors}
              setFieldValue={setFieldValue}
              rowSpan={5}
              value={values}
              values={months}
              required={true}
              enable={!selectedYear}
            />
          </Row>

          <Divider />

          <Row type="flex" justify="end" style={{ padding: '20px 0px 30px 0px' }}>
            <Col span={5}>
              <Button icon="search" className="bgPrimary" style={{ width: '100%' }} type="dashed" onClick={submitForm}>
                {getMessage('search')}
              </Button>
            </Col>
            <Col span={5}>
              <Button
                icon="close"
                style={{
                  width: '100%',
                  borderColor: '#EE778F',
                  color: '#EE778F'
                }}
                type="ghost"
                onClick={resetForm}
              >
                {getMessage('cleanFilters')}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default SearchCultivarsHistory
